import React, { useEffect, useState } from "react";
import {
    Form,
    AutoComplete,
    Input,
    Row,
    Col,
    Select,
    Checkbox,
    Button,
    message,
    Radio,
} from "antd";
import { DeleteOutlined } from "@ant-design/icons";

export default function Vendor({ vendorIndex, items, handleOnchangeItemPrice, vendor, handleOnchangeVendor, deleteVendor, formStatus, form }) {
    const { Option } = Select;
    console.log('vendor', vendor);
    useEffect(() => {
        if (vendor) {
            form.setFieldsValue({
                [`vendors_pic_${vendorIndex}`]: vendor.pic,
                [`vendors_telp_${vendorIndex}`]: vendor.contact,
                [`vendors_currency_${vendorIndex}`]: vendor.currency,
                [`vendors_address_${vendorIndex}`]: vendor.address,
                [`vendors_discount_price${vendorIndex}`]: vendor.discount_price,
                [`vendors_payment_${vendorIndex}`]: vendor.payment,
                [`vendors_franco_${vendorIndex}`]: vendor.franco,
                [`vendors_warranty_${vendorIndex}`]: vendor.warranty,
                [`vendors_duration_${vendorIndex}`]: vendor.duration,
                [`vendors_description_${vendorIndex}`]: vendor.description,
                [`vendors_tax_${vendorIndex}`]: vendor.tax,
            });
        }
    }, [vendor, vendorIndex, form]);
    return (
        <div className="mb-5">
            <div className="alert alert-warning d-flex justify-content-between w-100">
                <div style={{ flex: 1 }}>
                    {vendor.name} - {vendor.quotation_number}
                </div>
                <Button
                    type="text"
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => deleteVendor(vendorIndex)}
                />
            </div>
            <Row gutter={10} className="mb-1">
                <Col>
                    <Form.Item
                        label="PIC"
                        name={`vendors_pic_${vendorIndex}`}
                        rules={[
                            {
                                required: true,
                                message: "Please input ",
                            },
                        ]}>
                        <Input onChange={(e) => handleOnchangeVendor(vendorIndex, 'pic', e.target.value)}></Input>
                    </Form.Item>
                </Col>
                <Col>
                    <Form.Item
                        label="Telp"
                        name={`vendors_telp_${vendorIndex}`}
                        rules={[
                            {
                                required: true,
                                message: "Please input",
                            },
                        ]}>
                        <Input onChange={(e) => handleOnchangeVendor(vendorIndex, 'contact', e.target.value)}></Input>
                    </Form.Item>
                </Col>
                <Col>
                    <Form.Item
                        label="Currency"
                        name={['vendors_currency_', vendorIndex]}
                        rules={[
                            {
                                required: true,
                                message: "Please input",
                            },
                        ]}>
                        <Select placeholder="Select an option" onChange={(e) => handleOnchangeVendor(vendorIndex, 'currency', e)}>
                            <Option value="IDR">IDR</Option>
                            <Option value="USD">USD</Option>
                            <Option value="AUD">AUD</Option>
                            <Option value="EURO">EURO</Option>
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={10} className="mb-1">
                <Col xs={{ span: 23 }} sm={{ span: 7 }} xl={{ span: 7 }}>
                    <Form.Item
                        label="Address"
                        name={`vendors_address_${vendorIndex}`}
                        rules={[
                            {
                                required: true,
                                message: "Please input ",
                            },
                        ]}>
                        <Input.TextArea rows={4} style={{ width: '100%' }} value={vendor.address} onChange={(e) => handleOnchangeVendor(vendorIndex, 'address', e.target.value)} />
                    </Form.Item>
                </Col>
            </Row>
            <table className="table table-bordered table-striped table-hover">
                <thead>
                    <tr>
                        <th>Items</th>
                        <th>Qty</th>
                        <th>Price before</th>
                        <th>Price after</th>
                        <th>Total Price</th>
                    </tr>
                </thead>
                <tbody>
                    {items?.map((item, index) => (
                        <tr>
                            <td>
                                {item.name}
                            </td>
                            <td>{item.qty}</td>
                            <td><input value={vendor.items[index].price_before} step={0.000001} type="number" className="form-control form-control-sm" onChange={(e) => handleOnchangeItemPrice(vendorIndex, index, "price_before", e.target.value)}></input></td>
                            <td><input value={vendor.items[index].price_after} step={0.000001} type="number" className="form-control form-control-sm" onChange={(e) => handleOnchangeItemPrice(vendorIndex, index, "price_after", e.target.value)}></input></td>
                            <td>{item.qty * item.price_after}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <hr />
            <div>
                <div className="d-flex justify-content-between w-100">
                    <div>Total</div>
                    <div>{vendor.total_price}</div>
                </div>
                <div className="d-flex justify-content-between w-100">
                    <div>Pajak</div>
                    <div>{Math.round(vendor.tax_price)}</div>
                </div>
                <div className="d-flex justify-content-between w-100">
                    <div>Grand Total</div>
                    <div>{Math.round(vendor.grand_total)}</div>
                </div>
            </div>
            <hr />

            <div className=" row">
                <label className="col-md-3 col-sm-12">Discount</label>
                <div className="col-md-9 col-sm-12">
                    <Form.Item
                        type="number"
                        min={0}
                        name={['vendors_discount_price', vendorIndex]}
                        rules={[
                            {
                                required: true,
                                message: "Please input",
                            },
                        ]}>
                        <Input onChange={(e) => handleOnchangeVendor(vendorIndex, "discount_price", e.target.value)}></Input>
                    </Form.Item>
                </div>
            </div>
            <div className=" row">
                <label className="col-md-3 col-sm-12">Pajak</label>
                <div className="col-md-9 col-sm-12">
                    <Form.Item
                        rules={[
                            {
                                required: true,
                                message: "Please input",
                            },
                        ]}
                        name={['vendors_tax_', vendorIndex]} 
                        >
                        <Select placeholder="Select an option"
                            onChange={(e) => handleOnchangeVendor(vendorIndex, "tax", e)} style={{ width: '100%' }} defaultValue={vendor.tax_price}
                        >
                            <Option value="0"></Option>
                            <Option value="11">PPN 11%</Option>
                        </Select>
                    </Form.Item>
                </div>
            </div>
            <div className=" row">
                <label className="col-md-3 col-sm-12">Payment</label>
                <div className="col-md-9 col-sm-12">
                    <Form.Item
                        name={['vendors_payment_', vendorIndex]}
                        rules={[
                            {
                                required: true,
                                message: "Please input",
                            },
                        ]}>
                        <Input onChange={(e) => handleOnchangeVendor(vendorIndex, "payment", e.target.value)}></Input>
                    </Form.Item>
                </div>
            </div>
            <div className=" row">
                <label className="col-md-3 col-sm-12">Franco</label>
                <div className="col-md-9 col-sm-12">
                    <Form.Item
                        name={['vendors_franco_', vendorIndex]}
                        rules={[
                            {
                                required: true,
                                message: "Please input",
                            },
                        ]}>
                        <Input onChange={(e) => handleOnchangeVendor(vendorIndex, "franco", e.target.value)} ></Input>
                    </Form.Item>
                </div>
            </div>
            <div className=" row">
                <label className="col-md-3 col-sm-12">Warranty</label>
                <div className="col-md-9 col-sm-12">
                    <Form.Item
                        name={['vendors_warranty_', vendorIndex]}
                        rules={[
                            {
                                required: true,
                                message: "Please input",
                            },
                        ]}>
                        <Input onChange={(e) => handleOnchangeVendor(vendorIndex, "warranty", e.target.value)}></Input>
                    </Form.Item>
                </div>
            </div>
            <div className=" row">
                <label className="col-md-3 col-sm-12">Delivery Time</label>
                <div className="col-md-9 col-sm-12">
                    <Form.Item
                        name={['vendors_duration_', vendorIndex]}
                        rules={[
                            {
                                required: true,
                                message: "Please input",
                            },
                        ]}>
                        <Input onChange={(e) => handleOnchangeVendor(vendorIndex, "duration", e.target.value)}></Input>
                    </Form.Item>
                </div>
            </div>
            <div className=" row">
                <label className="col-md-3 col-sm-12">Description</label>
                <div className="col-md-9 col-sm-12">
                    <Form.Item
                        name={['vendors_description_', vendorIndex]}
                        rules={[
                            {
                                required: true,
                                message: "Please input",
                            },
                        ]}>
                        <Input onChange={(e) => handleOnchangeVendor(vendorIndex, "description", e.target.value)} ></Input>
                    </Form.Item>
                </div>
            </div>
            <div style={{ marginBottom: '100px' }}></div>
        </div>
    )
}